import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as managementAPI from 'api/Settings/management';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';
import { TYPE_OF_PAGE } from 'pages/setting/Tabs/Managment/constants';

const initalState = {
  pageSize: 10,
  currentPage: 1,
  selectedPage: TYPE_OF_PAGE.MAIN,
  lob: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Lob Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'No_Of_Teams', key: 'no_of_teams', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Created_AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  team: {
    data: null,
    totalRecords: 0,
    allLobs: [],
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Team Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Shift Timings', key: 'shift_timings', type: TYPE_OF_FIELD_IN_COLUMN.TIME, width: 120 },
      { title: 'Shift Type', key: 'shift_types', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Active Working Days', key: 'active_working_days', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'LOB', key: 'lob', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Created-AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 210 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  user: {
    data: null,
    totalRecords: 0,
    allTeams: [],
    selectedUser: null,
    userVoiceSignatureData: [],
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'User Name', key: 'username', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Role', key: 'role', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Contact', key: 'phone_number', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Status', key: 'is_active', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Team', key: 'team', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 210 },
      { title: 'Created-AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 210 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  }
};

const getAllLobs = createAsyncThunk('settings/management/getAllLobs', async () => {
  const res = await managementAPI.getAllLobs();
  return res.data?.data;
});

const getAllTeams = createAsyncThunk('settings/management/getAllTeams', async () => {
  const res = await managementAPI.getAllTeams();
  return res.data?.data;
});

const getLobData = createAsyncThunk('settings/management/readLob', async (filter) => {
  const res = await managementAPI.getLobData(filter);
  return res.data?.data;
});

const updateLob = createAsyncThunk('settings/management/updateLob', async (params) => {
  const res = await managementAPI.updateLob(params);
  return res.data?.data;
});

const createLob = createAsyncThunk('settings/management/createLob', async (params) => {
  const res = await managementAPI.createLob(params);
  return res.data?.data;
});

const deleteLob = createAsyncThunk('settings/management/deleteLob', async (id) => {
  const res = await managementAPI.deleteLob(id);
  return res.data?.data;
});

const getTeamsData = createAsyncThunk('settings/management/readTeam', async (filter) => {
  const res = await managementAPI.getTeamsData(filter);
  return res.data?.data;
});

const updateTeam = createAsyncThunk('settings/management/updateTeam', async (params) => {
  const res = await managementAPI.updateTeam(params);
  return res.data?.data;
});

const createTeam = createAsyncThunk('settings/management/createTeam', async (params) => {
  const res = await managementAPI.createTeam(params);
  return res.data?.data;
});

const deleteTeam = createAsyncThunk('settings/management/deleteTeam', async (id) => {
  const res = await managementAPI.deleteTeam(id);
  return res.data?.data;
});

const getUsersData = createAsyncThunk('settings/management/readUsers', async (filter) => {
  const res = await managementAPI.getUsersData(filter);
  return res.data?.data;
});

const updateUser = createAsyncThunk('settings/management/updateUser', async (params) => {
  const res = await managementAPI.updateUser(params);
  return res.data?.data;
});

const updateUserProfilePic = createAsyncThunk('settings/management/updateUserProfilePic', async (params) => {
  const res = await managementAPI.updateUserProfilePic(params);
  return res.data?.data;
});

const createUser = createAsyncThunk('settings/management/createUser', async (params) => {
  const res = await managementAPI.createUser(params);
  return res.data?.data;
});

const deleteUser = createAsyncThunk('settings/management/deleteUser', async (id) => {
  const res = await managementAPI.deleteUser(id);
  return res.data?.data;
});

const resetPassword = createAsyncThunk('settings/management/resetPassword', async (params) => {
  const res = await managementAPI.resetPassword(params);
  return res.data?.data;
});

const getUserVoiceSignature = createAsyncThunk('settings/management/getUserVoiceSignature', async (id) => {
  const res = await managementAPI.getUserVoiceSignature(id);
  return res.data?.data;
});

const deleteUserVoiceSignature = createAsyncThunk('settings/management/deleteUserVoiceSignature', async (id) => {
  const res = await managementAPI.deleteUserVoiceSignature(id);
  return res.data?.data;
});

const createUserVoiceSignature = createAsyncThunk('settings/management/createUserVoiceSignature', async (params) => {
  const res = await managementAPI.createUserVoiceSignature(params);
  return res.data?.data;
});
const Management = createSlice({
  name: 'management',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.user.selectedUser = action.payload;
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    }
  },
  extraReducers: {
    [getAllLobs.fulfilled]: (state, action) => {
      state.team.allLobs = action.payload;
    },

    [getAllTeams.fulfilled]: (state, action) => {
      state.user.allTeams = action.payload;
    },

    [getLobData.pending]: (state) => {
      state.lob.status = 'init';
      state.lob.ui.loading = true;
    },

    [getLobData.fulfilled]: (state, action) => {
      state.lob.status = 'idle';
      state.lob.ui.loading = false;
      state.lob.data = action.payload.results;
      state.lob.totalRecords = action.payload.count;
    },

    [getLobData.rejected]: (state, action) => {
      state.lob.status = 'error';
      state.lob.error = action.error.message;
      state.lob.ui.loading = false;
    },

    [updateLob.pending]: (state) => {
      state.lob.status = 'init';
      state.lob.ui.loading = true;
    },

    [updateLob.fulfilled]: (state, action) => {
      state.lob.status = 'idle';
      state.lob.ui.loading = false;
      const updatedData = state.lob.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.lob.data = updatedData;
    },

    [updateLob.rejected]: (state, action) => {
      state.lob.status = 'error';
      state.lob.error = action.error.message;
      state.lob.ui.loading = false;
    },

    [createLob.pending]: (state) => {
      state.lob.status = 'init';
      state.lob.ui.loading = true;
    },

    [createLob.fulfilled]: (state) => {
      state.lob.status = 'idle';
      state.lob.ui.loading = false;
    },

    [createLob.rejected]: (state, action) => {
      state.lob.status = 'error';
      state.lob.error = action.error.message;
      state.lob.ui.loading = false;
    },

    [deleteLob.pending]: (state) => {
      state.lob.status = 'init';
      state.lob.ui.loading = true;
    },

    [deleteLob.fulfilled]: (state) => {
      state.lob.status = 'idle';
      state.lob.ui.loading = false;
    },

    [deleteLob.rejected]: (state, action) => {
      state.lob.status = 'error';
      state.lob.error = action.error.message;
      state.lob.ui.loading = false;
    },

    [getTeamsData.pending]: (state) => {
      state.team.status = 'init';
      state.team.ui.loading = true;
    },

    [getTeamsData.fulfilled]: (state, action) => {
      state.team.status = 'idle';
      state.team.ui.loading = false;
      state.team.data = action.payload.results;
      state.team.totalRecords = action.payload.count;
    },

    [getTeamsData.rejected]: (state, action) => {
      state.team.status = 'error';
      state.team.error = action.error.message;
      state.team.ui.loading = false;
    },

    [updateTeam.pending]: (state) => {
      state.team.status = 'init';
      state.team.ui.loading = true;
    },

    [updateTeam.fulfilled]: (state, action) => {
      state.team.status = 'idle';
      state.team.ui.loading = false;
      const updatedData = state.team.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.team.data = updatedData;
    },

    [updateTeam.rejected]: (state, action) => {
      state.team.status = 'error';
      state.team.error = action.error.message;
      state.team.ui.loading = false;
    },

    [createTeam.pending]: (state) => {
      state.team.status = 'init';
      state.team.ui.loading = true;
    },

    [createTeam.fulfilled]: (state) => {
      state.team.status = 'idle';
      state.team.ui.loading = false;
    },

    [createTeam.rejected]: (state, action) => {
      state.team.status = 'error';
      state.team.error = action.error.message;
      state.team.ui.loading = false;
    },

    [deleteTeam.pending]: (state) => {
      state.team.status = 'init';
      state.team.ui.loading = true;
    },

    [deleteTeam.fulfilled]: (state) => {
      state.team.status = 'idle';
      state.team.ui.loading = false;
    },

    [deleteTeam.rejected]: (state, action) => {
      state.team.status = 'error';
      state.team.error = action.error.message;
      state.team.ui.loading = false;
    },

    [getUsersData.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [getUsersData.fulfilled]: (state, action) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
      state.user.data = action.payload.results;
      state.user.totalRecords = action.payload.count;
    },

    [getUsersData.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [updateUser.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [updateUser.fulfilled]: (state, action) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
      const updatedData = state.user.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.user.data = updatedData;
    },

    [updateUser.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [createUser.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [createUser.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [createUser.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [deleteUser.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [deleteUser.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [deleteUser.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [updateUserProfilePic.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [updateUserProfilePic.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [updateUserProfilePic.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [resetPassword.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [resetPassword.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [resetPassword.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [deleteUser.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [deleteUser.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [deleteUser.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [updateUserProfilePic.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [updateUserProfilePic.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [updateUserProfilePic.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [resetPassword.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [resetPassword.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [resetPassword.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [createUserVoiceSignature.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [createUserVoiceSignature.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [createUserVoiceSignature.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [deleteUserVoiceSignature.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [deleteUserVoiceSignature.fulfilled]: (state) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
    },

    [deleteUserVoiceSignature.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    },

    [getUserVoiceSignature.pending]: (state) => {
      state.user.status = 'init';
      state.user.ui.loading = true;
    },

    [getUserVoiceSignature.fulfilled]: (state, action) => {
      state.user.status = 'idle';
      state.user.ui.loading = false;
      state.user.userVoiceSignatureData = action.payload;
    },

    [getUserVoiceSignature.rejected]: (state, action) => {
      state.user.status = 'error';
      state.user.error = action.error.message;
      state.user.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize, setSelectedUser, setSelectedPage } = Management.actions;

export default Management.reducer;

export {
  getLobData,
  createLob,
  updateLob,
  deleteLob,
  getTeamsData,
  createTeam,
  updateTeam,
  deleteTeam,
  getAllLobs,
  getUsersData,
  createUser,
  updateUser,
  deleteUser,
  getAllTeams,
  updateUserProfilePic,
  resetPassword,
  createUserVoiceSignature,
  deleteUserVoiceSignature,
  getUserVoiceSignature
};
